<template>
    <div class="pcn-mobile-header">
        <button type="button" class="pcn-header-icon" :aria-label="$t('tabbar.menu')" @click="$emit('menu')"><AccountIcon name="menu" /></button>
        <button type="button" class="pcn-header-brand" :aria-label="brand" @click="$emit('home')"><img v-if="logo && !logoFailed" :src="logo" :alt="brand" @error="logoFailed = true" /><span v-else>{{ brand }}</span></button>
        <div class="pcn-header-wallet"><button type="button" class="pcn-header-refresh" :aria-label="refreshLabel" :disabled="refreshing" @click="$emit('refresh')"><AccountIcon name="refresh" :class="{ 'pcn-refreshing': refreshing }" /></button><span>{{ ready ? formatCurrency(balance, 2, false) : '—' }}</span><button type="button" class="pcn-header-deposit" :aria-label="$t('deposit.Deposit')" @click="$emit('deposit')"><AccountIcon name="arrow" /></button></div>
        <button type="button" class="pcn-header-icon pcn-header-notifications" :aria-label="$t('person.Notification')" @click="$emit('notifications')"><AccountIcon name="notification" /><span v-if="Number(notifications) > 0">{{ notifications }}</span></button>
    </div>
</template>
<script>
import AccountIcon from './accountIcon.vue'
export default {
    name: 'ProfileMobileHeader',
    components: { AccountIcon },
    props: { logo: String, brand: String, balance: [String, Number], ready: Boolean, refreshing: Boolean, notifications: [String, Number] },
    computed: {
        refreshLabel() { return ({ es_MX: 'Actualizar saldo', en_US: 'Refresh balance', pt_BR: 'Atualizar saldo', ru_RU: 'Обновить баланс' })[this.$i18n.locale] || 'Refresh balance' }
    },
    data() { return { logoFailed: false } },
    watch: { logo() { this.logoFailed = false } }
}
</script>
